import { ReturnRequestButton } from "../return-request-button/return-request-button";

export default function NavActions() {
  return (
    <div className={"flex flex-row items-center gap-2"}>
      <ReturnRequestButton />
    </div>
  );
}
